/**
 * Bloc personnalisé : classe portrait / paysage selon les dimensions réelles
 * de la photo (sans recadrage — le cadre s'adapte à l'image).
 */
(function () {
  if (window.__dasiBlocPersoImg) return;
  window.__dasiBlocPersoImg = true;

  function orient(img) {
    const wrap = img.closest('.bloc-perso-section__visual');
    if (!wrap) return;
    const w = img.naturalWidth;
    const h = img.naturalHeight;
    if (!w || !h) return;
    wrap.classList.remove(
      'bloc-perso-section__visual--portrait',
      'bloc-perso-section__visual--landscape',
    );
    wrap.classList.add(
      w >= h
        ? 'bloc-perso-section__visual--landscape'
        : 'bloc-perso-section__visual--portrait',
    );
  }

  function init() {
    document.querySelectorAll('.bloc-perso-section__img').forEach((img) => {
      if (img.complete && img.naturalWidth) orient(img);
      else img.addEventListener('load', () => orient(img), { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
